import ItemView from "./ItemView";

export default class ExampleItemView extends ItemView {
    constructor(target) {
        super(target);
    }
}